export default __webpack_public_path__ + "static/media/evergreen-meadow.3b89826e.png";